import { useAuth } from "../contexts/AuthContext";
import AccessDeniedPage from "../pages/AccessDeniedPage";

const LeadProtectedRoute = ({ children }) => {
  const { hasLeadCreateAccess } = useAuth();

  return hasLeadCreateAccess() ? children : <AccessDeniedPage />;
};

export default LeadProtectedRoute;
